export function getFeedbackUrl() {
    let feedbackUrl = "feedback-hub://?contextid=1214&tabid=2";
    if (window.localStorage && typeof window.localStorage.getItem === "function") {
        for (const key of ["muid", "rid", "debugId"]) {
            const val = window.localStorage.getItem(`mee-${key}`);
            if (val) {
                feedbackUrl = `${feedbackUrl}&${key}=${val}`;
            }
        }
    }
    return feedbackUrl;
}
export function fireFeedbackClickEvent() {
    dispatchEvent(new CustomEvent("FeedbackClicked"));
}
